<template>
	<div class="chargingManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">充电管理</div>
		</div>
		<div class="mainBot ">
			<div class="contentTop">
				<statisticalAnalysis></statisticalAnalysis>
			</div>
			<div class="contentBot">
				<chargingRecord></chargingRecord>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import chargingRecord from "./chargingRecord/chargingRecord.vue"
	import statisticalAnalysis from "./statisticalAnalysis/statisticalAnalysis.vue"
	export default {
		name: "chargingManage",
		components: {
			chargingRecord,
			statisticalAnalysis
		},
		data() {
			return {
				
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			getData() {
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargingManage.scss";
</style>
